import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import asyncComponent from '../../../util/asyncComponent';

const Expenses = ({ match }) => (
  <div className="app-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/all`} />


      <Route path={`${match.url}/all`} component={asyncComponent(() => import('./routes/all'))} />
      <Route path={`${match.url}/filter`} component={asyncComponent(() => import('./routes/filter'))} />
      <Route path={`${match.url}/export-purolator`} component={asyncComponent(() => import('./routes/export-purolator'))} />

    </Switch>
  </div>
);

export default Expenses;
